import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetReferrerResponse, ILinkReferralAccountApi } from './referralTypes';

export const linkReferralAccount = async (
  referralLink: string,
): Promise<ILinkReferralAccountApi> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post<ILinkReferralAccountApi>(
    `/referral-link`,
    { link: referralLink },
    {
      headers,
    },
  );

  return response.data;
};

export const getReferrer = async (): Promise<IGetReferrerResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetReferrerResponse>('/referrer', {
    headers,
  });

  return response.data;
};

export const referralApi = {
  linkReferralAccount,
  getReferrer,
};
